__turbopack_context__.v({
  "em-sig-editor-new-fields-section": "EmailSignatureEditorPanelNewFieldsSection-module-scss-module__mWeoLG__em-sig-editor-new-fields-section",
  "em-sig-new-fields-helper": "EmailSignatureEditorPanelNewFieldsSection-module-scss-module__mWeoLG__em-sig-new-fields-helper",
  "tip-badge": "EmailSignatureEditorPanelNewFieldsSection-module-scss-module__mWeoLG__tip-badge",
});
